import { STATUS } from '../../features/admin/events/Constants';

function isFencable(event) {
    return (event && (event.status !== STATUS.DONE &&
            event.status !== STATUS.ONGOING && event.status !== STATUS.INCOMING) );
}

function isPensionable(event) {
    return (event && (event.status === STATUS.ONGOING || event.status === STATUS.DONE));
}

export { isFencable, isPensionable };


// WEBPACK FOOTER //
// ./src/helper/event/statusHelper.js